import { Breakpoint, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { Form, IFormProps } from './form';
import { useConfirm, useScreenSize } from '@dw/hooks';

export interface IModalPropsBase {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface IModalProps<TFormType = any> extends IModalPropsBase {
  children: React.ReactNode;
  formWrapper?: IFormProps<TFormType>
  actions?: React.ReactNode;
  maxWidth?: Breakpoint | false
  contentTopPadding?: string;
  confirmBackdropClose?: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Modal<TFormType = any>(props: IModalProps<TFormType>) {

  const {
    title,
    open,
    onClose,
    children,
    actions,
    formWrapper,
    maxWidth,
    contentTopPadding,
    confirmBackdropClose
  } = props;

  const { confirm } = useConfirm();
  const { isMobile } = useScreenSize();

  const closeDialog = (isBackdropClick: boolean) => {
    if (!confirmBackdropClose || !isBackdropClick) {
      onClose();
    } else {
      confirm({
        title: 'Discard Changes?',
        message: 'Are you sure you want to discard your changes?',
        positiveText: 'Discard Changes',
        onPositive: () => {
          onClose();
        }
      })
    }
  }

  const dialogBody = (
    <>
      {title && (
        <DialogTitle>{title}</DialogTitle>
      )}
      <DialogContent sx={{
        padding: isMobile ? '18px 15px' : undefined,
        paddingTop: contentTopPadding ? `${contentTopPadding} !important` : undefined
      }}>
        {children}
      </DialogContent>
      {actions && (
        <DialogActions>
          {actions}
        </DialogActions>
      )}
    </>
  )

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => closeDialog(reason === 'backdropClick' || reason === 'escapeKeyDown')}
      maxWidth={maxWidth}
    >
      {formWrapper ? (
        <Form {...formWrapper}>
          {dialogBody}
        </Form>
      ) : dialogBody}
    </Dialog>
  )
}